export const STANDARD_DATE_FORMAT = `MM/DD/YYYY`;
